import React, { useContext, useEffect } from 'react';
import { AccessTypeEnum, EntityTypeEnum, FileOutDTO } from '@api/ringil-api.v2';
import { ApiContext } from '@api/api';
import useTranslationLgs from '@hooks/i18n/useTranslation';
import { useTranslation } from 'react-i18next';
import { useCreateAttachmentComponent } from '@components/ringil3/Features/Attachments/AttachementComponent.tsx';

interface ComponentProps {
  documents: FileOutDTO[];
  onDelete: (documentId: string) => void;
  applicationId: string;
  companyId: string;
  disabled?: boolean;
  disabledUpload?: boolean;
  expeditionId: string;
}

interface DeleteDocumentInfo {
  documentId: string;
  visible: boolean;
}

const TabDocuments: React.FC<ComponentProps> = ({
                                                  documents,
                                                  onDelete,
                                                  companyId,
                                                  applicationId,
                                                  expeditionId,
                                                  disabled = false,
                                                  disabledUpload,
                                                }) => {
  const { t }: { t: any } = useTranslation('common');
  const { tr } = useTranslationLgs();

  const { deleteDocumentForEntity, changeDocumentVisibility } = useContext(ApiContext);

  useEffect(() => {
    load();
  }, []);

  const load = () => {
    loadAttachments(EntityTypeEnum.EXPEDITION, expeditionId);
  };

  const { internals: attachmentInternals, load: loadAttachments, AttachmentComponent } = useCreateAttachmentComponent(
    {
      enableCopyDocument: false,
      enableDownloadZip: true,
      downloadZipApplicationId: applicationId,
    },
    {
      entityType: EntityTypeEnum.EXPEDITION,
      entityId: expeditionId,
      disabled: disabled,
      onDeletedAttachment: attachmentId => {
        deleteDocumentForEntity(EntityTypeEnum.EXPEDITION, expeditionId, attachmentId, () => {
          load();
        });
      },
      onChangeVisibility: (attachmentId, internal) => {
        changeDocumentVisibility(attachmentId, { accessType: internal ? AccessTypeEnum.INTERNAL : AccessTypeEnum.ALL }, () => {
          load();
        });
      }
    }
  );

  return (
    <>
      <AttachmentComponent
        internals={attachmentInternals}
        entityId={expeditionId}
        entityType={EntityTypeEnum.EXPEDITION}
        disabled={disabled}
        disabledUpload={disabledUpload}
      />
    </>
  );
};
export default TabDocuments;
